/**
 * @generated SignedSource<<79cc8fe117bedec1e8e5bfe792d98381>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type IncidentIoIntegration_integration$data = {
  readonly credentials: any;
  readonly id: any;
  readonly integrationType: IntegrationType;
  readonly name: string;
  readonly " $fragmentType": "IncidentIoIntegration_integration";
};
export type IncidentIoIntegration_integration$key = {
  readonly " $data"?: IncidentIoIntegration_integration$data;
  readonly " $fragmentSpreads": FragmentRefs<"IncidentIoIntegration_integration">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IncidentIoIntegration_integration",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "integrationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credentials",
      "storageKey": null
    }
  ],
  "type": "GraphQLIntegration",
  "abstractKey": null
};

(node as any).hash = "2dd6e4369906f96d26db85e16357ebd8";

export default node;
